import { KoobLoader, KoobPageHeader } from '@koob/ui';
import ProfileShow from './Show';
import ProfileLayout from '@koob/profile/src/layouts/ProfileLayout';
import useProfileHeader from '@koob/profile/src/useProfileHeader';
import { useApp } from '../../hooks';
import KoobLayout from '../../components/Koob/KoobLayout';

export default function ProfileContainer() {
  const { user } = useApp();
  const header = useProfileHeader();

  return user ? (
    <KoobLayout header={<KoobPageHeader {...header} />}>
      <ProfileLayout user={user}>
        <ProfileShow />
      </ProfileLayout>
    </KoobLayout>
  ) : (
    <KoobLoader centered />
  );
}
